





















import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import Modal from 'frontend/components/Modal.vue';

@Component({
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class PaywallSubscriptionNotice extends Vue {}
